import { create } from 'zustand';

export type StorageStatus = 'ok' | 'unavailable' | 'quota' | 'blocked';

interface StorageState {
  status: StorageStatus;
  dismissed: boolean;
  report: (kind: Exclude<StorageStatus, 'ok'>, err?: unknown) => void;
  dismiss: () => void;
}

/** Reports IndexedDB failures (FRE-171). Imports nothing from `db` so `db/index.ts` can use it. */
export const useStorageStore = create<StorageState>((set, get) => ({
  status: 'ok',
  dismissed: false,
  report: (kind, err) => {
    if (err) console.warn(`storage: ${kind}`, err);
    // 'unavailable' is the most severe: never downgrade it.
    if (get().status === 'unavailable' && kind !== 'unavailable') return;
    set({ status: kind, dismissed: false });
  },
  dismiss: () => set({ dismissed: true })
}));

export const reportStorage = (kind: Exclude<StorageStatus, 'ok'>, err?: unknown): void =>
  useStorageStore.getState().report(kind, err);
